import { z } from "zod";
export var ROOM_COLORING_IDS;
(function (ROOM_COLORING_IDS) {
    ROOM_COLORING_IDS["SPACE_BELONG_TO_STANDARD_ROOM"] = "SPACE_BELONG_TO_STANDARD_ROOM";
    ROOM_COLORING_IDS["SUPPLY_AIR_FLOW"] = "SUPPLY_AIR_FLOW";
    ROOM_COLORING_IDS["RETURN_AIR_FLOW"] = "RETURN_AIR_FLOW";
    ROOM_COLORING_IDS["MMI"] = "MMI";
    ROOM_COLORING_IDS["CEILING_MMI"] = "CEILING_MMI";
    ROOM_COLORING_IDS["DR_STATUS"] = "DR_STATUS";
    ROOM_COLORING_IDS["DESIGN_DEVIATION_STATUS"] = "DESIGN_DEVIATION_STATUS";
    ROOM_COLORING_IDS["ROOM_NUMBERING"] = "ROOM_NUMBERING";
    ROOM_COLORING_IDS["CEILING_COMMENTS"] = "CEILING_COMMENTS";
})(ROOM_COLORING_IDS || (ROOM_COLORING_IDS = {}));
const ZScopedArticleColoringId = z.union([
    z.string().regex(/^specifiedArticles\.listType:.+$/),
    z.string().regex(/^specifiedArticles\.responsibility:.+$/),
]).refine(id => {
    const encoded = id.slice(id.indexOf(":") + 1);
    try {
        const decoded = decodeURIComponent(encoded);
        return decoded.trim().length > 0 && encodeURIComponent(decoded.trim()) === encoded;
    }
    catch {
        return false;
    }
}, "Invalid encoded coloring scope");
/** Validates filter IDs, not whether the current project has data for the filter. */
export const ZRoomColoringId = z.union([
    z.nativeEnum(ROOM_COLORING_IDS),
    z.string().regex(/^standardRoom\.[^\s.:]+$/),
    z.string().regex(/^decision:standardRoom\.[^\s.:]+$/),
    z.literal("specifiedArticles.overall"),
    ZScopedArticleColoringId,
]);
